import api from "./axios";

export const initiateKybApi = async () => {
	const response = await api.post("/api/kyb/initiate");
	return response.data;
};

export const getKybStatusApi = async (kycId: string) => {
	const response = await api.get(`/api/kyb/status/${kycId}`);
	return response.data;
};

export const verifyKybEmailTokenApi = async (token: string) => {
	const response = await api.get(`/api/kyb/verify-email`, {
		params: { token },
	});
	return response.data;
};

// Note: redirectUrl is accepted for call-site compatibility (KYBVerification.tsx
// passes it) but, as in the original JS, is not forwarded in the request body.
export const submitCompanyEmailApi = async (kycId: string, { email }: { email: string; redirectUrl?: string }) => {
	const response = await api.post(`/api/kyb/company-email/${kycId}`, { email });
	return response.data;
};

export const check2faApi = async (kycId: string) => {
	const response = await api.get(`/api/kyb/check-2fa/${kycId}`);
	return response.data;
};

type KybVerificationError = Error & { verificationFailed?: boolean; confidence?: number };

export const uploadKybDocumentApi = async (
	kycId: string,
	file: File,
	{ documentType, businessName }: { documentType?: string; businessName?: string } = {},
) => {
	const formData = new FormData();
	formData.append("document", file);
	if (documentType) formData.append("documentType", documentType);
	if (businessName) formData.append("businessName", businessName);
	const response = await api.post(`/api/kyb/document/${kycId}`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	// API returns 200 even on match failure — surface it as an error
	const result = response.data;
	if (result?.data?.verified === false) {
		const err: KybVerificationError = new Error(result?.data?.message || result?.message || "Document verification failed.");
		err.verificationFailed = true;
		err.confidence = result?.data?.confidence;
		throw err;
	}
	return result;
};
